import {FC} from 'react'
import {Link} from 'react-router-dom'
import {SubmitHandler} from 'react-hook-form'
import {EMAIL_TYPES} from 'consts/emailType'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Form} from './parts/Form'
import {LoadingPlaceholder} from './parts/LoadingPlaceholder'
import {DefaultEmail, CustomEmail} from './query'
import {Schema} from './schema'

interface PresenterProps {
  mailType: keyof typeof EMAIL_TYPES
  loading: boolean
  defaultEmail?: DefaultEmail
  customEmail?: CustomEmail
  onSubmit: SubmitHandler<Schema>
}

export const Presenter: FC<PresenterProps> = ({mailType, loading, defaultEmail, customEmail, onSubmit}) => {
  return (
    <>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">メールカスタマイズ</h1>
        <p className="m-title-main-note">メールの内容をカスタマイズできます</p>
      </div>
      <div className="l-wrap-xs l-contents-wrap">
        <div className="l-breadcrumb u-mb20">
          <Link to={WITH_AUTH_ADMIN_PATHS.SETTINGS.INDEX} className="l-breadcrumb-link">
            設定
          </Link>
          <Link to={WITH_AUTH_ADMIN_PATHS.SETTINGS.CUSTOM_MAILS.INDEX} className="l-breadcrumb-link">
            メールカスタマイズ
          </Link>
          <span className="l-breadcrumb-here">{EMAIL_TYPES[mailType]}</span>
        </div>
        {loading || !defaultEmail ? (
          <LoadingPlaceholder />
        ) : (
          <Form
            title={EMAIL_TYPES[mailType]}
            defaultEmail={defaultEmail}
            customEmail={customEmail}
            onSubmit={onSubmit}
          />
        )}
      </div>
    </>
  )
}
